/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {EmailNotificationDefinition} from './EmailNotificationDefinition';

export const EmailNotifications = yup.object({
   definitions: yup
      .array()
      .of(EmailNotificationDefinition)
      .default(EmailNotificationDefinition.cast({})),
   addendum: yup.string(),
   itDebug: yup.boolean(),
   itAddendum: yup.string(),
   abbreviateNotifications: yup.boolean(),
});
export type IEmailNotifications = yup.InferType<typeof EmailNotifications>;
